define((require) => {
    "use strict";

    var $                               = require("jquery"),
        EditorEvents                    = require("shared/services/EditorEvents"),
        ImageToggleEffectModel          = require("shared/ui/experience/action/effects/ImageToggleEffectModel"),
        ImageToggleEffectPropertiesView = require("ui/experience/action/properties/ImageToggleEffectPropertiesView"),
        ImprovedView                    = require("editor/zbone/ImprovedView"),
        OpacityEffectModel              = require("shared/ui/experience/action/effects/OpacityEffectModel"),
        OpacityPropertiesView           = require("ui/experience/widgets/OpacityPropertiesView"),
        PulseEffectModel                = require("shared/ui/experience/action/effects/PulseEffectModel"),
        PulseEffectPropertiesView       = require("ui/experience/action/properties/PulseEffectPropertiesView"),
        RotateEffectModel               = require("shared/ui/experience/action/effects/RotateEffectModel"),
        RotateEffectPropertiesView      = require("ui/experience/action/properties/RotateEffectPropertiesView"),
        ScaleEffectModel                = require("shared/ui/experience/action/effects/ScaleEffectModel"),
        ScaleEffectPropertiesView       = require("ui/experience/action/properties/ScaleEffectPropertiesView"),
        template                        = require("ui/experience/action/EffectLibraryView.tpl"),
        Effect                          = require("shared/ui/experience/action/effects/EffectModel"),
        WidgetTypes                     = require("shared/ui/experience/widgets/WidgetTypes");

    /**
     * The set of default effects - supported by all widgets.
     *
     * @type {String[]}
     */
    var DEFAULT_EFFECTS = [OpacityEffectModel.TYPE, ScaleEffectModel.TYPE, PulseEffectModel.TYPE, RotateEffectModel.TYPE];

    var EMAIL_EFFECTS_MODE = [OpacityEffectModel.TYPE];

    var ACTIVE_EFFECTS_MODE = DEFAULT_EFFECTS;

    var effectTypeToPropertiesView = new Map();

    effectTypeToPropertiesView.set(OpacityEffectModel.TYPE, OpacityPropertiesView);
    effectTypeToPropertiesView.set(ImageToggleEffectModel.TYPE, ImageToggleEffectPropertiesView);
    effectTypeToPropertiesView.set(ScaleEffectModel.TYPE, ScaleEffectPropertiesView);
    effectTypeToPropertiesView.set(PulseEffectModel.TYPE, PulseEffectPropertiesView);
    effectTypeToPropertiesView.set(RotateEffectModel.TYPE, RotateEffectPropertiesView);

    // Specific effects for specific widgets
    var concreteWidgetEffects = new Map();

    concreteWidgetEffects.set(WidgetTypes.IMAGE.id, [ImageToggleEffectModel.TYPE]);

    /**
     * The effect library view, contains the subviews for different effect types.
     *
     * @class EffectLibraryView
     *
     * @cfg {AbstractWidgetModel} model The widget model being edited.
     */
    return ImprovedView.extend({

        _enabled: false,
        _currentEffect: null,
        isEmailModeEnabled: false,

        template: template,

        templateHelpers: function() {
            return {
                triggerType: this.options.triggerType
            };
        },

        ui: {
            hoverProperties: ".hover-effect-properties",
            attentionProperties: ".attention-effect-properties",
            libraryEffect: ".effect-library .effect",
            effectConfiguration: ".effect-configuration",
            slider: ".slider",
            sliderValue: ".slider-value",
            timingEffectConfiguration: ".timing-effect-configuration"
        },

        regions: {
            effectConfigurationRegion: ".effect-configuration-region"
        },

        events: {
            "click .effect": "_effectClickHandler"
        },

        initialize: function() {
            this._enabled = this.options.effects.hasTriggerType(this.options.triggerType);
            this._currentEffect = this._selectedEffect();
        },

        enabled: function(flag) {
            if (this._enabled === flag) {
                return;
            }

            if (flag) {
                this._addSelectedEffect();
                this._showPropertiesView();
            } else {
                this.options.effects.removeByTriggerType(this.options.triggerType);
            }

            this._enabled = flag;
            if (this._enabled && this.options.viewModel.get("experience").get("emailModeEnabled")) {
                this._turnOnEffect(true);
            }
        },

        _selectedEffect: function() {
            return this.options.effects.firstByTriggerType(this.options.triggerType);
        },

        _applyEffectsSet() {
            this.isEmailModeEnabled = this.options.viewModel.get("experience").get("emailModeEnabled");
            ACTIVE_EFFECTS_MODE = this.isEmailModeEnabled && Effect.TRIGGER_TYPE_HOVER === this.options.triggerType
                ? EMAIL_EFFECTS_MODE
                : DEFAULT_EFFECTS;
        },

        _effectClickHandler: function(event, element) {
            var $element = element || $(event.target),
                effectType = $element.attr("data-target"),
                disabled = $element.hasClass("disabled"),
                uiEffectType;

            // If disabled or already selected - bail out
            if (disabled || !!this._selectedEffect() && effectType === this._selectedEffect().get("type")) {
                return;
            }

            this._selectEffectUI(effectType);
            this._addSelectedEffect();
            this._showPropertiesView();

            switch (effectType) {
                case "scale":
                    uiEffectType = "resize";
                    break;

                case "imageToggle":
                    uiEffectType = "imageSwap";
                    break;
                default:
                    uiEffectType = effectType;
            }


            var triggerType = this.options.triggerType === "attention" ? "loop" : this.options.triggerType,
                viewModel = this.viewScope.viewModel,
                experience = viewModel.get("experience"),
                eventProperties = {
                    widgetType: this.model.get("type"),
                    updatedProperty: "effect",
                    updatedValue: triggerType + "-" + uiEffectType,
                    experienceId: experience.get("id"),
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion"),
                    sceneNumber: viewModel.get("sceneNumber"),
                    triggerOrigin: "WidgetMenuEffectCheckbox"
                };

            // Fire event for tracking Mix Panel events via Segment
            EditorEvents.trigger(EditorEvents.constants.UPDATE_WIDGET, eventProperties);
        },

        _addSelectedEffect: function() {
            var effectType = this.$(".effect.selected").attr("data-target"),
                previousEffect = this._currentEffect;

            // We only allow a single effect per trigger type
            this.options.effects.removeByTriggerType(this.options.triggerType, {silent: true});

            // Lookup the effect class
            var EffectClass = this.options.effects.classFromType(effectType);

            this._currentEffect = new EffectClass({triggerType: this.options.triggerType});
            // Add the selected effect to the collection
            this.options.effects.add(this._currentEffect);
            this._bindTimingToEffectModel(previousEffect);
        },

        _bindTimingToEffectModel: function(previousModel) {
            this.unstickit(previousModel);

            this.stickit(this._currentEffect, {
                ".duration": {
                    observe: "duration",
                    onGet: function(value) {
                        return value / 1000;
                    },

                    onSet: function(value) {
                        return value * 1000;
                    }
                },
                ".post-delay": {
                    observe: "postDelay",
                    onGet: function(value) {
                        return value / 1000;
                    },

                    onSet: function(value) {
                        return value * 1000;
                    }
                }
            });
        },

        /**
         * @private
         *
         * Renders the selected effect in the UI.
         *
         * @param  {String} effectType The effect type, e.g. <tt>opacity</tt>.
         */
        _selectEffectUI: function(effectType) {
            // Deselect all effects in library
            this.ui.libraryEffect.removeClass("selected");

            var target = this.$("[data-target='" + effectType + "']");

            // Select clicked effect in library
            target.addClass("selected");

            // Disable timing-panel on the attention-effect pulse
            this.ui.timingEffectConfiguration.toggleClass("show", effectType !== "pulse" && this.options.triggerType === "attention");
        },

        _showPropertiesView: function() {
            // Show config to selected effect
            var selectedEffect = this._selectedEffect();
            if (selectedEffect) {
                var PropertiesViewClass = effectTypeToPropertiesView.get(selectedEffect.get("type"));
                this.effectConfigurationRegion.show(new PropertiesViewClass({model: selectedEffect}));
            }
        },

        _turnOnEffect: function(firstEnable = false) {
            if (this._enabled) {
                const selectedEffect = this._selectedEffect();
                const allAccessibleEffects = ACTIVE_EFFECTS_MODE.concat(concreteWidgetEffects.get(this.model.get("type")));
                const currentEffectType = selectedEffect && !firstEnable ? selectedEffect.get("type") : null;
                const accessibleEffect = allAccessibleEffects.find((type) => currentEffectType === type);
                const currentAccessibleEffectType = accessibleEffect || allAccessibleEffects[0];
                this._selectEffectUI(currentAccessibleEffectType);
                if (!accessibleEffect && firstEnable) {
                    this._addSelectedEffect();
                }
                this._showPropertiesView();
                this._bindTimingToEffectModel();
            }
        },

        onRender: function() {
            this._applyEffectsSet();
            this._turnOnEffect();

            // Only enable effects that are supported by the current widget
            this.$(".effect").each((i, element) => {
                var effectElement = $(element),
                    effectType = effectElement.attr("data-target"),
                    effectEnabled = true;

                // If it's not a default effect - check to see if it's supported
                // by the current widget
                if (ACTIVE_EFFECTS_MODE.indexOf(effectType) === -1) {
                    var widgetEffects = concreteWidgetEffects.get(this.model.get("type"));
                    effectEnabled = widgetEffects && widgetEffects.indexOf(effectType) !== -1;
                }

                // Apply the disabled class if not supported
                effectElement.toggleClass("disabled", !effectEnabled);
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/EffectLibraryView.js